var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCollectionsNotFoundLight = function SvgCollectionsNotFoundLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#F3F3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.75,
    y: 10.75,
    width: 138.5,
    height: 138.5,
    rx: 69.25,
    stroke: "#F3F3F8",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 116,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 14,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "collections-not-found-light_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 24,
    width: 160,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 56h16.05a10.004 10.004 0 0 1 8.64-8.915C64.87 33.095 81.372 24 100 24c18.627 0 35.13 9.094 45.311 23.085 4.577.6 8.181 4.295 8.64 8.915H170c5.523 0 10 4.477 10 10v28c0 5.523-4.477 10-10 10h-16.049a10.005 10.005 0 0 1-8.64 8.915C135.13 126.906 118.627 136 100 136s-35.13-9.094-45.31-23.085A10.005 10.005 0 0 1 46.05 104H30c-5.523 0-10-4.477-10-10V66c0-5.523 4.477-10 10-10Z",
    fill: "red"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#collections-not-found-light_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#F3F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 60,
    width: 80,
    height: 48,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.75,
    y: 56.75,
    width: 78.5,
    height: 46.5,
    rx: 9.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.75 66a9.25 9.25 0 0 1 9.25-9.25h60a9.25 9.25 0 0 1 9.25 9.25v21.25h-78.5V66Z",
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.75,
    y: 66.75,
    width: 22.5,
    height: 22.5,
    rx: 5.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 94,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.843 80.62c1.196 1.281.285 3.371-1.468 3.366l-5.749-.017c-1.752-.005-2.651-2.1-1.447-3.374l2.884-3.05a2 2 0 0 1 2.915.01l2.865 3.066Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 74,
    r: 2,
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 60,
    width: 80,
    height: 48,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 56.75,
    width: 78.5,
    height: 46.5,
    rx: 9.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 66A9.25 9.25 0 0 1 30 56.75h60A9.25 9.25 0 0 1 99.25 66v21.25h-78.5V66Z",
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 66.75,
    width: 22.5,
    height: 22.5,
    rx: 5.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 94,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.843 80.62c1.196 1.281.285 3.371-1.468 3.366l-5.75-.017c-1.751-.005-2.65-2.1-1.446-3.374l2.884-3.05a2 2 0 0 1 2.915.01l2.865 3.066Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 74,
    r: 2,
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 52.5,
    width: 108,
    height: 66,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.75,
    y: 47.75,
    width: 106.5,
    height: 64.5,
    rx: 9.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.75 57A9.25 9.25 0 0 1 56 47.75h88a9.25 9.25 0 0 1 9.25 9.25v33.25H46.75V57Z",
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.85,
    y: 61.5,
    width: 30.9,
    height: 31.5,
    rx: 5.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.1,
    y: 99.25,
    width: 43.2,
    height: 5.5,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.012 82.134c1.179 1.285.264 3.358-1.48 3.352l-11.114-.033c-1.744-.005-2.646-2.084-1.46-3.361l5.576-6.004a2 2 0 0 1 2.94.009l5.538 6.037Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.9,
    cy: 71.75,
    rx: 2.7,
    ry: 2.75,
    fill: "#CFCDDC"
  }))));
};

export { SvgCollectionsNotFoundLight as ReactComponent };
export default "data:image/svg+xml;base64,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";